var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sceneContainer",attrs:{"id":"scene-container"}},[_c('div',{ref:"uiContainer",attrs:{"id":"ui-container"}},[_c('Nav'),(_vm.isVisible)?_c('Welcome',{on:{"triggered":_vm.startedScene}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }